// extracted by mini-css-extract-plugin
export default {"fourteen-days-icon":"YwgKoa","fourteenDaysIcon":"YwgKoa","credit-card-icon":"RWx9R1","creditCardIcon":"RWx9R1"};